import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeText } from '../traitTypes/TraitTypeText';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
import { TraitTypeSwitchButtons } from '../traitTypes/TraitTypeSwitchButtons';
import { TraitTypeNumericWithSlider } from '../traitTypes/TraitTypeNumericWithSlider';
export class TraitRegistryAspectHtml extends TraitRegistryCategory {
    label = 'Html';
    constructor(data) {
        super(data);
        this.initDynamicAttributes();
        super.init();
    }
    className = () => new TraitTypeText({
        label: 'CSS Klasse',
        multiple: true,
        default: '',
        css: () => [],
        classNames: ({ at }) => [at.traitValue],
    });
    jsxTag = () => new TraitTypeSelect( /*
        label: 'HTML Tag',
        init: 'div',
        select: [['div'], ['img'], ['span'], ['p'], ['h1'], ['h2'], ['h3'], ['a']] */);
    jsx_attr_draggable = () => new TraitTypeSelect( /*{
      default: 'false',
      init: 'true',
      select: [['true'], ['false']]
    }*/);
    jsx_attr_name = () => new TraitTypeText({
        multiple: true,
        default: '',
    });
    jsx_attr_id = () => new TraitTypeText({
        default: '',
    });
    jsx_attr_data_textgrowmin = () => new TraitTypeText();
    jsx_attr_data_textgrowmax = () => new TraitTypeText();
    jsx_attr_data_fontsizemanual = () => new TraitTypeSwitchButtons( /*{
      label: 'Manual Font Size',
      select: [
        [1, 'ja'],
        [0, 'nein']
      ]
    }*/);
    initDynamicAttributes() {
        const tags = Object.keys(html);
        for (const tag of tags) {
            const tagObject = html[tag];
            const tagProps = Object.keys(tagObject);
            for (const tagProp of tagProps) {
                const propObj = tagObject[tagProp];
                const setting = {
                    label: `JSX Attribut ${tag} ${tagProp}`,
                    Type: TraitTypeText,
                    ...propObj,
                };
                const { Type, ...init } = setting;
                this[`jsx_${tag}_${tagProp}`] = new Type({ ...init });
            }
        }
    }
}
const html = {
    a: {
        href: {},
        target: { default: '', init: '_blank', Type: TraitTypeSelect, select: [['_blank'], ['']] },
    },
    img: {
        src: {},
    },
    div: {},
    input: {
        size: {},
        value: {},
        inputMode: { Type: TraitTypeSelect, select: [['decimal'], ['text'], ['numeric']] },
        disabled: { default: '', init: 'disabled', Type: TraitTypeSelect, select: [['disabled'], ['']] },
    },
    svg: { preserveAspectRatio: { default: '', init: 'none', Type: TraitTypeSelect, select: [['none'], ['']] } },
    rect: { x: { Type: TraitTypeNumericWithSlider, min: 0, max: 1000 }, y: {}, rx: {}, ry: {} },
    polygon: { points: { default: '' } },
};
